import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DocumentsHubPage.css';

const DOCUMENT_TOOLS = [
  {
    id: 'risk',
    icon: '⚠️',
    title: 'Risk Analizi',
    subtitle: '6331 Sayılı İSG Kanunu – Madde 10',
    description: '23 sektöre göre önceden tanımlı standart riskler, L Matrisi / Fine-Kinney / FMEA metodolojileri ve yasal kanun maddeleri ile otomatik PDF ve rapor üretimi.',
    badge: 'AKTİF',
    badgeColor: '#16a34a',
    color: '#1e3a5f',
    gradient: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
    path: '/documents/risk',
    features: ['23 Sektör Arşivi', '100+ Risk Kalemi', 'PDF Rapor', 'Kanun Maddeleri'],
  },
  {
    id: 'emergency',
    icon: '🚨',
    title: 'Acil Durum Eylem Planı',
    subtitle: '6331 Sayılı İSG Kanunu – Madde 11',
    description: 'İşyerine özel acil tahliye prosedürleri, toplanma noktaları, görevli listeleri ve tatbikat planını içeren kapsamlı Acil Durum Eylem Planı belgesi.',
    badge: 'AKTİF',
    badgeColor: '#16a34a',
    color: '#7c2d12',
    gradient: 'linear-gradient(135deg, #7c2d12 0%, #dc2626 100%)',
    path: '/documents/emergency',
    features: ['Tahliye Planı', 'Görev Listesi', 'Toplanma Noktası', 'Tatbikat Takvimi'],
  },
  {
    id: 'evacuation-plan',
    icon: '🗺️',
    title: 'Tahliye & Vaziyet Krokisi',
    subtitle: 'Binaların Yangından Korunması Hakkında Yönetmelik – Madde 70',
    description: 'İşyerinize özel interaktif mimari duvar çizimi, dinamik ölçek hesabı, yangın tüpü, acil çıkış kapıları ve toplanma alanı sembolleri ile yüksek çözünürlüklü tahliye planı ve resmi A3/A4 Word çıktısı.',
    badge: 'AKTİF',
    badgeColor: '#16a34a',
    color: '#0f766e',
    gradient: 'linear-gradient(135deg, #0f766e 0%, #0d9488 100%)',
    path: '/documents/evacuation-plan',
    features: ['İnteraktif Duvar Çizimi', 'Dinamik Ölçek & Metraj', 'CAD Sembolleri', 'Word (.docx) & PNG İndir'],
  },
  {
    id: 'annual',
    icon: '📅',
    title: 'Yıllık Çalışma Planı',
    subtitle: 'Madde 8 – İSG Profesyonellerinin Yükümlülükleri',
    description: 'İSG uzmanı ve işyeri hekiminin yıllık çalışma planını otomatik oluşturan, matris takvimi, periyodik kontroller ve imza bloklarını içeren resmi belge üretici.',
    badge: 'AKTİF',
    badgeColor: '#16a34a',
    color: '#065f46',
    gradient: 'linear-gradient(135deg, #065f46 0%, #059669 100%)',
    path: '/documents/annual-work',
    features: ['Matris Takvimi', 'Otomatik Bilgiler', 'Word (.docx) İndir', 'Yazdır / PDF'],
  },
  {
    id: 'annual-training',
    icon: '🎓',
    title: 'Yıllık Eğitim Planı',
    subtitle: 'Çalışanların İSG Eğitimleri Yönetmeliği',
    description: 'Tehlike sınıfına göre (Az Tehlikeli: 8s, Tehlikeli: 12s, Çok Tehlikeli: 16s) yasal eğitim konularını, periyot matrisini ve imza alanlarını içeren belge üretici.',
    badge: 'AKTİF',
    badgeColor: '#16a34a',
    color: '#0369a1',
    gradient: 'linear-gradient(135deg, #0369a1 0%, #0284c7 100%)',
    path: '/documents/annual-training',
    features: ['3 Tehlike Sınıfı', 'Genel, Sağlık, Teknik', 'Word (.docx) İndir', 'Yazdır / PDF'],
  },
  {
    id: 'certificates',
    icon: '📄',
    title: 'Sertifika Yönetimi',
    subtitle: 'İSG Mevzuatı – KKD, Yangın, Tahliye Sertifikaları',
    description: 'Excel listesi yükleyerek sistemdeki Word şablonu üzerinden tüm çalışanlar için tek tıkla otomatik sertifikalar üretin ve ZIP olarak indirin.',
    badge: 'AKTİF',
    badgeColor: '#16a34a',
    color: '#4c1d95',
    gradient: 'linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%)',
    path: '/documents/certificates',
    features: ['Excel ile Toplu Üretim', 'Word (.docx) Şablonu', 'Otomatik ZIP İndirme', 'Dinamik Etiketler'],
  },
  {
    id: 'drill',
    icon: '🔥',
    title: 'Tatbikat ve Eğitim Kaydı',
    subtitle: 'Madde 17 – Çalışanların İSG Eğitimleri',
    description: 'Yangın, tahliye ve ilkyardım tatbikatlarının katılımcı listeleriyle birlikte belgelenmesi ve resmi eğitim katılım formu üretimi.',
    badge: 'YAKINDA',
    badgeColor: '#d97706',
    color: '#7c2d12',
    gradient: 'linear-gradient(135deg, #78350f 0%, #d97706 100%)',
    path: '/documents/drill',
    features: ['Katılımcı Listesi', 'İmzalı Form', 'Tarih Kaydı', 'PDF Rapor'],
  },
];

export const DocumentsHubPage: React.FC = () => {
  const navigate = useNavigate();

  const handleToolClick = (tool: typeof DOCUMENT_TOOLS[0]) => {
    if (tool.badge !== 'AKTİF') return;
    navigate(tool.path);
  };

  return (
    <div className="wfd-page">
      {/* Header */}
      <div className="wfd-header">
        <div className="wfd-header-content">
          <div className="wfd-header-icon">📂</div>
          <div>
            <h1 className="wfd-title">Belge Yönetimi</h1>
            <p className="wfd-subtitle">
              6331 Sayılı İş Sağlığı ve Güvenliği Kanunu kapsamında resmi yasal belge üretim ve yönetim araçları
            </p>
          </div>
        </div>
        <div className="wfd-header-badge">
          <span className="wfd-legal-ref">İSG Mevzuatı Uyumlu</span>
        </div>
      </div>

      {/* Info Strip */}
      <div className="wfd-info-strip">
        <span className="wfd-info-icon">⚖️</span>
        <span>
          Bu araçlar ile üretilen belgeler, <strong>6331 Sayılı İSG Kanunu</strong> ve ilgili yönetmeliklere uygun standart format ve içerik ile hazırlanmaktadır.
          Belgelerin yasal geçerliliği için yetkili İSG profesyonelleri ve işveren onayı gereklidir.
        </span>
      </div>

      {/* Tool Cards Grid */}
      <div className="wfd-grid">
        {DOCUMENT_TOOLS.map(tool => (
          <div
            key={tool.id}
            className={`wfd-card ${tool.badge === 'AKTİF' ? 'wfd-card--active' : 'wfd-card--soon'}`}
            onClick={() => handleToolClick(tool)}
          >
            <div className="wfd-card-header" style={{ background: tool.gradient }}>
              <div className="wfd-card-icon">{tool.icon}</div>
              <div className="wfd-card-badge" style={{ background: tool.badgeColor }}>
                {tool.badge}
              </div>
            </div>
            <div className="wfd-card-body">
              <h2 className="wfd-card-title">{tool.title}</h2>
              <p className="wfd-card-law">{tool.subtitle}</p>
              <p className="wfd-card-desc">{tool.description}</p>
              <div className="wfd-card-features">
                {tool.features.map(f => (
                  <span key={f} className="wfd-feature-tag">{f}</span>
                ))}
              </div>
            </div>
            <div className="wfd-card-footer">
              {tool.badge === 'AKTİF' ? (
                <button
                  className="wfd-btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleToolClick(tool);
                  }}
                >
                  Belge Oluştur →
                </button>
              ) : (
                <button className="wfd-btn-soon" disabled>
                  Yakında Kullanıma Açılacak
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Legal footer */}
      <div className="wfd-footer-note">
        <strong>📋 Yasal Dayanak:</strong> İş Sağlığı ve Güvenliği Kanunu (6331), İSG Risk Değerlendirmesi Yönetmeliği (R.G. 29.12.2012/28512),
        Çalışanların İSG Eğitimleri Hakkında Yönetmelik (R.G. 15.05.2013/28648), Binaların Yangından Korunması Hakkında Yönetmelik ve ilgili mevzuat kapsamında hazırlanmıştır.
      </div>
    </div>
  );
};

export default DocumentsHubPage;
